import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContextSupabase'
import { ProgressSpinner } from 'primereact/progressspinner'

export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user, isAdmin, loading } = useAuth()
  console.log('isAdmin', isAdmin)

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: 'var(--surface-ground)',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '1rem',
          }}
        >
          <ProgressSpinner
            style={{ width: '60px', height: '60px' }}
            strokeWidth="4"
          />
          <p style={{ color: 'var(--text-color-secondary)' }}>認証中...</p>
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (!isAdmin) {
    // Redirect non-admin users to home page
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
